import { z } from 'zod'

import { TeamDomainQueryModelSchema } from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { TeamQueryShapeSchema } from '../types.ts'

export const GetTeamInputSchema = TeamDomainQueryModelSchema.pick({
  teamId: true,
})

export type GetTeamInput = ZodInfer<typeof GetTeamInputSchema>

export const TeamAclSchema = z.object({
  canUpdateTeam: z.boolean(),
  canUpdateTeamProfile: z.boolean(),
})

export const GetTeamOutputSchema = TeamQueryShapeSchema.extend({
  acl: TeamAclSchema,
})
export type GetTeamOutput = ZodInfer<typeof GetTeamOutputSchema>
